<template>
  <v-container grid-list-md class="pb-3 pt-1 pr-0 pl-3 break-all">
    <v-layout class="max-width" row wrap>
      <template v-if="data.value instanceof Array">
        <span class="font-weight-medium">{{ splitByCapitalLetter(data.name) }}:</span>
        <span v-if="data.value.length == 0">&nbsp;None</span>
        <div v-else class="max-width">
          <TreeView v-for="(value, index) in data.value" :key="index" :data="{ value }" />
        </div>
      </template>
      <template v-else-if="data.value instanceof Object">
        <div v-if="data.name" class="font-weight-medium max-width">
          {{ data.name }}:
        </div>
        <TreeView v-for="(value, name, index) in data.value" :key="index" :data="{ value, name, index }" />
      </template>
      <template v-else>
        <template v-if="!!data.name">
          <span class="font-weight-medium">{{ splitByCapitalLetter(data.name) }}:</span>
          &nbsp;{{ data.value }}
        </template>
        <div v-else class="max-width">- {{ data.value }} </div>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
  import {
    splitByCapitalLetter,
  } from '@/helpers/strings'

  export default {
    name: 'TreeView',
    props: {
      data: Object,
    },
    methods: {
      splitByCapitalLetter,
    },
  }
</script>

<style scoped>
  .break-all {
    word-break: break-all;
  }
</style>